/** Hand the browser a file to save.
 *
 *  One implementation, shared. It started module-private in
 *  `components/Chat/SessionSidebar.tsx` with `body: string`, which was fine while
 *  the only caller was the session transcript export. The table exporters
 *  (`lib/export/xlsx.ts`, `lib/export/pdf.ts`) return a `Blob` of real binary, so
 *  the body widened to `Blob | string` and moved here — a markdown table's export
 *  menu must not import the session sidebar to get a download, and a fourth
 *  copy-pasted downloader is how the three that already exist happened.
 *
 *  A `Blob` is passed through untouched. It is NOT re-wrapped or coerced: a
 *  stringified .xlsx is `"[object Blob]"`, which downloads perfectly and then
 *  fails to open — a corrupt file with no error is the worst outcome on this
 *  path, because the user finds out later and somewhere else.
 */
export function downloadBlob(
  filename: string,
  body: Blob | string,
  /** Media type for a string body. Ignored for a Blob, which carries its own. */
  mime?: string,
): void {
  const blob = typeof body === "string" ? new Blob([body], { type: mime }) : body;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after a tick so Safari doesn't race the download.
  setTimeout(() => URL.revokeObjectURL(url), 100);
}
